import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './login/AuthGuardService';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminComponent } from './admin/admin.component';
import { UserComponent } from './user/user.component';
import { FormUserComponent } from './user/form/form-user.component';
import { PasswordComponent } from './change/change.component';

const routes: Routes = [

  {
    path :'',
    component : LoginComponent
  },

  {
    path: 'admin',
    component:AdminComponent,
    children : [

      {
        path :'dashboard',
        component : DashboardComponent,
        canActivate: [AuthGuardService]
      },


      {
        path :'users',
        component : UserComponent,
        canActivate: [AuthGuardService]
      },

      {
        path :'form-user',
        component : FormUserComponent,
        canActivate: [AuthGuardService]
      },

      {
        path :'change-password',
        component : PasswordComponent
      }


    ]
  },


  {
    path: 'contents',
    loadChildren: () => import('./content/content.module').then((m) => m.ContentModule),
    canActivate: [AuthGuardService]
  }


  


];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
